export default {"src":"//a.static-global.com/floxy/floxy-web-user-center-ssr/_next/static/media/sao-light.ff8630e7.svg","height":181,"width":123};